module.exports = __webpack_public_path__ + "img/dropsmith-bogo-desc.50b97240.png";